import { Select } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Icon } from './components-lib'
import { faCaretDown } from '@fortawesome/free-solid-svg-icons'
import css from './lang-switch-dropdown.css'
import { WidgetBackgroundStyle } from '../pages/home'
import { MainStyles } from '../stylesheet'

export const LangSwitchDropdown: React.FC<{ className?: string; style?: React.CSSProperties }> = ({ className, style }) => {
  const { i18n } = useTranslation()

  return i18n.languages.length > 1 ? (
    <WidgetBackgroundStyle>
      <Select
        className={`${className ?? ''} ${css.langSwitchDropdown}`}
        value={i18n.language}
        onChange={(lng) => i18n.changeLanguage(lng)}
        options={i18n.languages.map((lng) => ({ value: lng, label: lng.toUpperCase() }))}
        suffixIcon={<Icon icon={faCaretDown} color={MainStyles.colorBackgroundOpaque} style={{ padding: 0 }} />}
        style={style}
      />
    </WidgetBackgroundStyle>
  ) : (
    <></>
  )
}
